import script from "./StaticTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./StaticTable.vue?vue&type=script&lang=ts&setup=true"

import "./StaticTable.vue?vue&type=style&index=0&id=5d949d4d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d949d4d"]])

export default __exports__